export interface ISize {
    id: number;
    name: string;
}

const newSize = (): ISize => ({
    id: 0,
    name: '',
})

export const createSize = <T extends Partial<ISize>>(initialValues: T): ISize & T => {
    return Object.assign(newSize(), initialValues);
};